<template>
    <div>
        <ssam-talk-write-link
            v-for="writeLayout in writeLayouts"
            :key="`ssams${writeLayout}`"
            :writeLayout="writeLayout"
            :ssam-talk-data="ssamTalkData"
            :categoryList="categoryList"
        ></ssam-talk-write-link>
    </div>
  </template>
  
  
  <script>
  import EventBus from "@/utils/event-bus";
  import util from "@/mixins/util";
  import alertMixins from "@/mixins/alertMixins";
  import DeleteClass from "@/mixins/deleteClass";
  import elFileMixins from "@/mixins/elFileMixins";
  import SsamTalkWriteLink from "@/components/ssamtalk/link/SsamTalkWriteLink.vue";
  import ssamtalkUtil from "@/components/ssamtalk/ssamtalkUtil";
  import ssamTalkValidator from "@/components/ssamtalk/ssamTalkValidator";
  import vimeoPlugin from "@/plugins/vimeoPlugin";
  
  let vimeoParams = {
    privacy: {
        view: 'unlisted',
        comments: 'contacts',
        download: false,
        add: false,
    },
    embed: {
        buttons: {
            like: false,
            share: false,
            watchlater: false,
            embed: false,
        },
        logos: {
            vimeo: false,
        },
        title: {
            name: 'hide',
            owner: 'hide',
            portrait: 'hide'
        },
    },
  };
  export default {
    name: "SsamTalkWriteComponent",
    mixins: [alertMixins, ssamtalkUtil, elFileMixins, ssamTalkValidator],
    components: {SsamTalkWriteLink},
    inject: ['changeLoading'],
    provide() {
        return {
            ssamTalkWriteSetData: this.setData,
            openFinishSaveConfirm: this.openFinishSaveConfirm,
        };
    },
    props: {
        ssamTalkType: {default: ""},
        ssamTalkKey: {default: 0},
        setViewData: {type: Function, default: () => {}},
    },
    data() {
        return {
            ssamTalkData: {},
            getFunc: "",
            detailApiParamSet: {},
            writeLayouts: [],
            writeFunc: "",
            writeApiParamSet: {},
            parsingData: {},
            fileInfo: [],
            directUrl: "",
            directType: "",
            deleteKeyName: "",
            writeSuccessType: 1,
            writeSuccessMsg: "작성되었습니다.",
            writeFailTypes: {},
            writeFailMsg: "",
            isSetWriteVimeo: false,
            isSetUpdateVideo: false,
            isSetReference: false,
            isMoveDetailStatus: false,
            isRunning: false,
            deleteAlertMsg: '정말 삭제하시겠습니까?',
            deleteFunc: "",
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            DeleteClass: null,
            ssamsSnsList: {},
            isCategory: false,
            getCategoryFunc: '',
            categoryList: '',
            keyName: '',
  
            vimeoPlugin: null,
            isUploadVimeoKey: '',
        };
    },
    beforeRouterEnter() {
    },
    created() {
        this.initFilterConfig();
        if (this.ssamTalkKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getSsamTalk();
        }
    },
    mounted() {
        EventBus.$on("writeSsamTalk", this.writeSsamTalk);
        EventBus.$on("deleteSsamTalk", this.runDeleteConfirm);
    },
    beforeDestroy() {
        EventBus.$off("writeSsamTalk");
        EventBus.$off("deleteSsamTalk");
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;
            this.setViewData(key, value);
        },
        initTemplateConfig() {
            let config = this.returnSsamTalkConfig(this.ssamTalkType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnSsamTalkConfig(this.ssamTalkType);
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.fileInfo = config.fileInfo;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.keyName = config.keyName;
            this.writeKeyName = config.writeKeyName;
            this.deleteKeyName = config.deleteKeyName;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.deleteAlertMsg = config.deleteAlertMsg ?? this.deleteAlertMsg;
            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;
            this.isSetWriteVimeo = config.isSetWriteVimeo ?? this.isSetWriteVimeo;
            this.isSetUpdateVideo = config.isSetUpdateVideo ?? this.isSetUpdateVideo;
            this.isSetReference = config.isSetReference ?? this.isSetReference;
            this.isMoveDetailStatus = config.isMoveDetailStatus ?? this.isMoveDetailStatus;
            this.newDeleteClass();
            if (this.isCategory === true) {
                this.getSsamTalkCategory();
            }
            this.vimeoPlugin =  new vimeoPlugin();
            this.vimeoPlugin.init(vimeoParams);
        },
        getSsamTalk() {
            let params = Object.assign({}, this.detailApiParamSet);
            params[this.keyName] = this.ssamTalkKey;
            EventBus.$emit("apiLoading", true);
            try {
                this.$api.$ssamtalk[this.getFunc](params)
                    .then((res) => res.Data.Result)
                    .then((res) => {
                        if (res.Info.type !== 1 || util.isEmpty(res.List)) {
                            this.errorAlert("데이터를 불러올 수 없습니다.");
                            this.$router.back();
                            return false;
                        }
                        if (res.List.hasOwnProperty('SsamTalk')) {
                            this.ssamTalkData = res.List.SsamTalk[0]
                        } else {
                            this.ssamTalkData = res.List[0];
                        }
  
                        EventBus.$emit("apiLoading", false);
                        this.initTemplateConfig();
                    });
            } catch (e) {
                console.log(e);
                EventBus.$emit("apiLoading", false);
            }
        },
        getSsamTalkCategory() {
            let params = {ip: 0};
            try {
                this.$api.$ssamtalk[this.getCategoryFunc](params).then((res) => res.Data.Result).then((res) => {
                    if (res.Info.type !== 1 || util.isEmpty(res.List)) {
                        this.errorAlert("데이터를 불러올 수 없습니다.");
                        this.$router.back();
                        return false;
                    }
                    this.categoryList = res.List;
                });
            } catch (e) {
                console.log(e);
                EventBus.$emit("apiLoading", false);
            }
        },
  
        _checkValidator() {
            let validatorArr = Object.keys(this.parsingData);
  
            return this.$validate(validatorArr).then((success) => {
                if (!success) {
                    this.errorAlert("필수데이터를 확인해주세요.");
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success;
                }
                return success;
            });
        },
        _makeParams() {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                if(paramKey != '') {
                    params[paramKey] = this[dataKey];
                }
            });
  
            if (this.ssamTalkKey !== 0) {
                params[this.writeKeyName] = this.ssamTalkKey;
            }
  
            return params;
        },
        _makeBookListParams(params) {
            //let bookParams = params;
            let references = [];
            util.Array.each(this.bookList, (item, index, book) => {
                references.push({sr_reference_name: item.name, sr_reference_link: item.url})
            });
            if(this.isSetReference) {
                params.reference = references;
            }
            return params;
        },
  
        _uploadingVimeo(isSetWriteVimeo=false) {
            this.changeLoading(true)
            return new Promise(resolve => {
                if(!isSetWriteVimeo) {
                    resolve(false);
                    return false;
                }
                if(this.videoFile.length == 0 || util.isEmpty(this.videoFile[0].raw)) {
                    resolve(false);
                    return false;
                }
                this.vimeoPlugin.runUpload(this.videoFile[0].raw, this.isUploadVimeoKey).then(res => {
                    let uri = res;
                    let cv_vimeo = uri.replace('/videos/', '');
                    resolve(cv_vimeo);
                    return cv_vimeo;
                }, err => {
                    this.vimeoPlugin.runUpload(this.videoFile[0].raw).then(resUpload => {
                        let uri = resUpload;
                        let cv_vimeo = uri.replace('/videos/', '');
                        resolve(cv_vimeo);
                        return cv_vimeo;
                    }, err => {
                        this.changeLoading(false)
                        this.errorAlert('비디오 업로드에 실패하였습니다.');
                        resolve(false);
                        return false;
                    })
                });
            })
        },
  
        async writeSsamTalk() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
  
            let validator = await this._checkValidator();
            if (!validator) {
                this.isRunning = false;
                return false;
            }
            if(util.isEmpty(this.videoFile)) {
                this.errorAlert('비디오 파일을 등록해주세요.');
                this.isRunning = false;
                return false;
            }
  
            //let vimeoId = await this._uploadingVimeo(this.isSetWriteVimeo)
  
            EventBus.$emit("apiLoading", true);
            let params = this._makeParams();
            /*if(vimeoId != false) {
                params.sbv_vimeo = vimeoId;
            }*/
            params = this._makeBookListParams(params);
  
            try {
                this.$api.$ssamtalk[this.writeFunc](params)
                    .then((res) => res.Data.Result)
                    .then(async (res) => {
                        let type = this.returnWriteType(res.Info.type);
                        if (type !== true) {
                            this.errorAlert(type);
                            EventBus.$emit("apiLoading", false);
                            return (this.isRunning = false);
                        }
                        if (!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles);
                        }
                        let key = this.ssamTalkKey > 0 ? this.ssamTalkKey : Number(res.List)
                        await this.uploadFile(key);
                        this.uploadVimeo(key);
                    });
            } catch (e) {
                console.log(e);
                this.isRunning = false;
                EventBus.$emit("apiLoading", false);
            }
        },
        async uploadFile(key) {
            util.Array.each(this.fileInfo, (data, index, arr) => {
                let file = this[data.fileName];
                let checkFile = !util.isEmpty(file) && file.filter((files) => files.hasOwnProperty("raw")).length > 0;
                if (checkFile) {
                    for (let i = 0; i < this.files.length; i++) {
                        file[i].a_seq = i;
                    }
                    this.uploadFiles(file, data.fileType, key).then(success => {
  
                    });
                }
            });
        },
        async uploadVimeo(key) {
            let vimeoId = await this._uploadingVimeo(this.isSetWriteVimeo)
            if(vimeoId == false) {
                this.afterFunc(key);
                return;
            }
            EventBus.$emit("apiLoading", true);
            let params = {
                type: 'video',
                sbv_vimeo: vimeoId,
            }
            params[this.writeKeyName] = key;
            try {
                this.$api.$ssamtalk.updateSsamTalk(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type == 1) {
                        this.afterFunc(key);
                    } else {
                        this.errorAlert('비디오 업로드에 실패하였습니다.');
                        this.writeLayouts = [];
                        this.getSsamTalk();
                    }
                })
            }catch (e) {
                console.log(e);
            }
  
        },
        returnWriteType(type) {
            if (type === this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type])
                    ? "저장 실패했습니다."
                    : this.writeFailTypes[type];
            }
        },
        afterFunc(key) {
            EventBus.$emit("apiLoading", false);
            // if(this.stepStatus === 0 && this.isMoveDetailStatus && this.ssamTalkKey == 0) {
            if(this.stepStatus === 0 && this.isMoveDetailStatus) {
                this.directType = 'detail';
                this.directUrl = '/ssamtalk/content/'
            }
            let content = "저장하였습니다.";
            this.createAlert({
                content: content,
                hide: () => {
                    if (this.directType === "back") {
                        this.$router.back();
                        EventBus.$emit("apiLoading", false);
                        return false;
                    }
                    if (this.directUrl === "") {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        EventBus.$emit("apiLoading", false);
                        this.getSsamTalk();
                        return false;
                    }
                    if (this.directType === "detail") {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        EventBus.$emit("apiLoading", false);
                        let url = this.directUrl + key;
                        this.$router.replace(url);
                        return false;
                    }
                    EventBus.$emit("apiLoading", false);
                    let url = this.directUrl;
                    this.$router.push(url);
                },
            });
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$ssamtalk[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.deleteKeyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                };
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDeleteConfirm() {
            this.createConfirm({
                content: this.deleteAlertMsg,
                confirmText: "삭제",
                confirm: () => {
                    this.runDelete();
                },
            });
        },
        runDelete() {
            EventBus.$emit("apiLoading", true);
            this.DeleteClass.runDelete(this.ssamTalkKey);
        },
        deleteAfterFunc() {
            EventBus.$emit("apiLoading", false);
            this.createAlert({
                content: "삭제가 완료되었습니다.",
                hide: () => {
                    this.$router.back();
                },
            });
        },
  
  
        openFinishSaveConfirm() {
            if(!this.ssamTalkData.hasOwnProperty('Step') || util.isEmpty(this.ssamTalkData.Step)) {
                this.createConfirm({
                content: 'STEP 미등록인 경우에 최종 제출 선택 시 기존 입력한 정보 기반으로 최종 제출하며 이후에 수정 불가능합니다. 저장하시겠습니까?',
                confirmText: '저장',
                cancelText: '취소',
                confirm: () => {
                    this.runFinishSave();
                }
            })
                // this.errorAlert('STEP은 최소 1개 존재해야 합니다.');
                return;
            }
            this.createConfirm({
                content: '제출시 수정이 불가합니다. 최종 제출하시겠습니까?',
                confirmText: '최종제출',
                cancelText: '취소',
                confirm: () => {
                    this.runFinishSave();
                }
            })
        },
        runFinishSave() {
            let params = {s_idx: this.ssamTalkKey};
            EventBus.$emit('apiLoading', true);
            try {
                this.$api.$ssamtalk.finishSsamTalk(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('apiLoading', false);
                    if(res.Info.type === 1) {
                        this.ssamTalkData = {};
                        this.detailLayout = '';
                        this.createAlert({
                            content: '최종제출 되었습니다.',
                            hide: () => {
                                this.initFilterConfig();
                                this.initTemplateConfig();
                                this.getSsamTalk();
                            }
                        })
                    }else {
                        this.errorAlert('최종제출에 실패하였습니다. 잠시후 다시 시도해주세요.')
                    }
                })
            }catch (e) {
                console.log(e);
            }
        },
    },
    watch: {},
  };
  </script>
  
  <style scoped></style>
  